import { Config } from "./config";

const liveRoomRelativePath = `${Config.CDN_URL}/liveroom`;

const LAYOUT_CDN_BASE_URL = "https://media.chingari.io/uploads/layout";

export const SEND_BTN = "/assets/icons/sendbtn.svg",
  CLOCK_ICON = "/assets/icons/clock-check.svg",
  CALENDER_ICON = "/assets/icons/calender-dark.svg",
  TOKEN_IMG = "/assets/images/monkey.png",
  BHAANG_IMG = "/assets/images/bhang.png",
  SOLANA = "/assets/images/solana.png",
  PLANET_IMG = "/assets/images/planet.png",
  STAR_IMG = "/assets/images/star-min.png",
  STAR_MC = "/assets/images/star.svg",
  CARD_BACK = "/assets/images/card-img.png",
  GLOBE_ICON = "/assets/icons/globe-icon.svg",
  LINK_EXTERNAL_ICON = "/assets/icons/link-external-icon.svg",
  TELEGRAM_ICON = "/assets/icons/telegram-icon.svg",
  THREE_DOT_ICON = "/assets/icons/three-dot-icon.svg",
  REPORT_ICON = "/assets/icons/report-icon.svg",
  SHARE_ICON = "/assets/icons/share-icon.svg",
  BLOCK_ICON = "/assets/icons/block-icon.svg",
  PENCIL_ICON = "/assets/icons/pencil-icon.svg",
  X_ICON = "/assets/icons/x-icon.svg",
  X_ICON_WHITE = "/assets/icons/X-white.svg",
  TASK = "/assets/icons/task.svg",
  CROSS_ICON = "/assets/icons/cross.svg",
  COPY_ICON = "/assets/icons/copy.svg",
  XP_COIN = "/assets/icons/xp_coin.svg",
  PODIUM = "/assets/icons/Podium.svg",
  CHEVRON_ICON_DOWN = "/assets/icons/chevron-down.svg",
  SB_FOR_YOU = "/assets/icons/for-you.svg",
  SB_EXPLORE = "/assets/icons/explore.svg",
  SB_HOW = "/assets/icons/how.svg",
  SB_CREATOR = "/assets/icons/creator.svg",
  SB_PROFILE = "/assets/icons/my-profile.svg",
  SB_PROFILE_ACTIVE = "/assets/icons/my-profile-selected.svg",
  F_CREATOR = "/assets/icons/f_creator.svg",
  F_FAQ = "/assets/icons/f_faq.svg",
  F_LIVE = "/assets/icons/f_live.svg",
  F_WALLET = "/assets/icons/f_wallet.svg",
  SOLANA_LOGO = "/assets/icons/solanaLogo.svg",
  LEFT_ARROW_ICON_BLUE = "/assets/icons/left-arrow-blue-icon.svg",
  IC_BACK = "/assets/icons/back.svg",
  IC_CLOSE = "/assets/icons/close.svg",
  IC_VIEWERS = "/assets/icons/viewers.svg",
  IC_PLUS = "/assets/icons/plus.svg",
  IC_EYE = "/assets/icons/eye-purple.svg",
  IC_GIFT = "/assets/icons/gift.svg",
  IC_CHAT = "/assets/icons/chat.svg",
  IC_COIN = "/assets/icons/coins-swap.svg",
  IC_WALLET = "/assets/icons/wallet.svg",
  IC_HISTORY = "/assets/icons/history.svg",
  IC_HOME = "/assets/icons/home.svg",
  IC_HOME_BLACK = "/assets/icons/home_b.svg",
  IC_GIFT_WHITE = "/assets/icons/gift-white.svg",
  IC_CHAT_WHITE = "/assets/icons/chat-white.svg",
  IC_ERROR = "/assets/icons/error.svg",
  IC_CALL = "/assets/icons/call-icon.svg",
  IC_CALL_FREE = "/assets/icons/call-icon-free.svg",
  IC_CROSS = "/assets/icons/cross.svg",
  IC_FIRE_ORANGE = "/assets/icons/fire-orange.svg",
  IC_MUTE = "/assets/icons/mute.svg",
  IC_UNMUTE = "/assets/icons/unmute.svg",
  IC_VCARD = "/assets/icons/VCard.svg",
  LEVEL_ICON = `${Config.CDN_URL}/levels/allLevels`,
  SOCIAL_BTN_APP_STORE = "/assets/icons/app-store.svg",
  SOCIAL_BTN_PLAY_STORE = "/assets/icons/play-store.svg",
  SOCIAL_BTN_APP_GALARY = "/assets/icons/app-galary.svg",
  SOCIAL_BTN_ANDROID = "/assets/icons/android.svg",
  IC_FIRE_WHITE = "/assets/icons/fire-white.svg",
  IC_RADIO_TICK = "/assets/icons/radio-tick.svg",
  DEFAULT_AVATAR = "/assets/icons/default-avatar.svg",
  USER_PROFILE_IMAGE = "/assets/icons/user_profile_image.svg",
  IC_BADGE = "/assets/icons/badge.svg",
  IC_FLAG = "/assets/icons/flag.svg",
  IC_CALENDAR = "/assets/icons/calendar.svg",
  IC_BACK_ICON = "/assets/icons/back-icon.svg",
  IC_DOTS_VERTICAL = "/assets/icons/dots-vertical.svg",
  IC_BRIEFCASE = "/assets/icons/briefcase.svg",
  IC_LANGUAGES = "/assets/icons/language-letters.svg",
  IC_PENCIL = "/assets/icons/pencil.svg",
  IC_DIAMOND_PURPLE = `${LAYOUT_CDN_BASE_URL}/diamond-purple.svg`,
  IC_QUESTION_MARK = "/assets/icons/question-mark.svg",
  IC_UPLOAD = "/assets/icons/add-icon.svg",
  CHINGARI_FIRE_IC = "/assets/icons/chingari-fire-icon.svg",
  CROSS_IC = "/assets/icons/cross.svg",
  FILTER = "/assets/icons/filter.svg",
  TIMER = "/assets/icons/timer.svg",
  CREATOR_LIVE = "/assets/icons/liveCreator.svg",
  CREATOR_ICON = "/assets/icons/creator_img.svg";

const SOME_IMG = "/assets/icons/someImg.svg";

export const Images = {
  diamondLarge: "/assets/icons/diamond_large.svg",
  upArrowBlack: "/assets/icons/upArrowNew.svg",
  downArrowBlack: "/assets/icons/downArrowNew.svg",
  ballon: "/assets/background/Ballon.svg",
  iconBack: "/assets/icons/back.svg",
  iconBackWhite: "/assets/icons/back-white.svg",
  iconBlackDown: "/assets/icons/black-down.svg",
  iconWhiteDown: "/assets/icons/white-down.svg",
  filter: "/assets/icons/filterNew.svg",
  redCross: "/assets/icons/red-cross.svg",
  blueTick: `/assets/icons/blue-tick.svg`,
  cross: `/assets/icons/cross-bl.svg`,
  BAR_CHART: "/assets/icons/bar-chart.svg",
  BOX: "/assets/icons/box.svg",
  COINS_SWAP: "/assets/icons/coins-swap.svg",
  COINS_SWAP_B: "/assets/icons/coins-swap-b.svg",
  INFO: "/assets/icons/info.svg",
  GLOBE: "/assets/icons/globe.svg",
};

export const PAGE_LINKS_ICONS = {
  LIVE_ROOMS: {
    icon: `${LAYOUT_CDN_BASE_URL}/live-rooms.svg`,
    activeIcon: `${LAYOUT_CDN_BASE_URL}/live-rooms-active.svg`,
  },
  AUDIO_CALL: {
    icon: `${LAYOUT_CDN_BASE_URL}/audio-call.svg`,
    activeIcon: `${LAYOUT_CDN_BASE_URL}/audio-call-active.svg`,
  },
  COMMUNITY: {
    icon: `${LAYOUT_CDN_BASE_URL}/community.svg`,
    activeIcon: `${LAYOUT_CDN_BASE_URL}/community-active.svg`,
  },
  FEEDS: {
    icon: `${LAYOUT_CDN_BASE_URL}/feed.svg`,
    activeIcon: `${LAYOUT_CDN_BASE_URL}/feed-active.svg`,
  },
  WALLET: {
    icon: `${LAYOUT_CDN_BASE_URL}/wallet.svg`,
    activeIcon: `${LAYOUT_CDN_BASE_URL}/wallet-active.svg`,
  },
  DIAMOND: {
    icon: `${LAYOUT_CDN_BASE_URL}/diamond.svg`,
    activeIcon: `${LAYOUT_CDN_BASE_URL}/diamond-active.svg`,
  },
  PROFILE: {
    icon: SB_PROFILE,
    activeIcon: SB_PROFILE_ACTIVE,
  },
};

const DOWNLOAD_ICONS: { [key: string]: string } = {
  IOS: "/assets/icons/ios.svg",
  ANDROID: "/assets/icons/android-store.svg",
  HUWAEI: "/assets/icons/huwaei.svg",
  PLAYSTORE: "/assets/icons/playstore.svg",
};

const ROOM_CONTAINER = {
  FAVICON: `${liveRoomRelativePath}/fav.png`,
  CHINGARI_LOGO: `${liveRoomRelativePath}/chingari-logo.webp`,
  FIRE_LOGO: `${liveRoomRelativePath}/chingari-fire-icon.svg`,
  USER: `${liveRoomRelativePath}/user.svg`,
  ARROW: `${liveRoomRelativePath}/arrow.svg`,
  PARTY: `${liveRoomRelativePath}/party.svg`,
  PLAY_STORE: `${liveRoomRelativePath}/play-store.webp`,
  APPLE_STORE: `${liveRoomRelativePath}/apple-store.webp`,
  DEFAULT_ROOM: `${liveRoomRelativePath}/default-room.webp`,
};

const CATEGORY_ICONS_DEV_URL = `/assets/icons`;

const CATEGORY_ICONS = {
  CATEGORY_IC_DATING: `${CATEGORY_ICONS_DEV_URL}/category_dating.svg`,
  CATEGORY_IC_ASTROLOGY: `${CATEGORY_ICONS_DEV_URL}/category_astrology.svg`,
  CATEGORY_IC_LEGAL: `${CATEGORY_ICONS_DEV_URL}/category_legal.svg`,
  CATEGORY_IC_HEALTH: `${CATEGORY_ICONS_DEV_URL}/category_health.svg`,
  CATEGORY_IC_FINANCE1: `${CATEGORY_ICONS_DEV_URL}/category_finance1.svg`,
  CATEGORY_IC_FINANCE2: `${CATEGORY_ICONS_DEV_URL}/category_finance2.svg`,
  CATEGORY_IC_STAR: `${CATEGORY_ICONS_DEV_URL}/category_star.svg`,
};

const LOGIN_FLOW_ICONS = {
  IC_PHONE: "/assets/icons/phone.svg",
  IC_GOOGLE: "/assets/icons/google.svg",
};

export const DEFAULT_USER_AVATAR = `${LAYOUT_CDN_BASE_URL}/default-avatar.svg`;

const FILTER_ICON = "/assets/icons/FilterIcon.svg";

const popupIconsDevLink = "/assets/icons/";

interface PROFILE_POPUP_ICONS_TYPE {
  EXPLORE_SECTION: { [key: string]: string };
  FOOTER_SECTION: { [key: string]: string };
  PRODUCT_CENTER: { [key: string]: string };
}
const PROFILE_POPUP_ICONS: PROFILE_POPUP_ICONS_TYPE = {
  EXPLORE_SECTION: {
    MESSAGE_ICON: `${popupIconsDevLink}message-icons.svg`,
    DIAMONDS_ICON: `${popupIconsDevLink}diamond-icons.svg`,
    DIAMONDS_SMALL_ICON: `${popupIconsDevLink}diamond-small-icons.svg`,
    GARI_ICON: `${popupIconsDevLink}gari-icons.svg`,
    TASK_ICON: `${popupIconsDevLink}task-icons.svg`,
    GARI_SMALL_ICON: `${popupIconsDevLink}gari-small-icon.svg`,
  },
  FOOTER_SECTION: {
    CONTENTACTIVITY_ICON: `${popupIconsDevLink}content-activity-dark-icon.svg`,
    SETTING_ICON: `${popupIconsDevLink}settings-icon.svg`,
    GARI_SOCIAL_ICON: `${popupIconsDevLink}gari-social-icon.svg`,
    LOGOUT_ICON: `${popupIconsDevLink}logout-icon.svg`,
    GRATERTHAN_ICON: `${popupIconsDevLink}graterThan-icon.svg`,
  },
  PRODUCT_CENTER: {
    QUESTS_ICON: `${popupIconsDevLink}quest-icon.svg`,
    REFER_ICON: `${popupIconsDevLink}referEarn-icon.svg`,
    VNFT_ICON: `${popupIconsDevLink}vNFT-icon.svg`,
  },
};
const REVIEW_POPUP_ICONS: { [keys: string]: string } = {
  REVIEW_IC_STAR: "/assets/icons/star-icon.svg",
  REVIEW_IC_STAR_golden: "/assets/icons/star-golden-icon.svg",
  REVIEW_IC_BACK_BLACK: "/assets/icons/back-black-Icon.svg",
};

const TOAST_ICON: { [keys: string]: string } = {
  SUCCESS: "/assets/icons/toast-success-color.svg",
  ERROR: "/assets/icons/toast-error-color.svg",
  WARNIG: "/assets/icons/toast-warning-color.svg",
};

const UPI_PAYMENTS = {
  GPAY: "https://devmedia.chingari.io/apipublic/upi_icons/gpay.png",
  PAYTM: "https://devmedia.chingari.io/apipublic/upi_icons/paytm.png",
  PHONEPE: "https://devmedia.chingari.io/apipublic/upi_icons/phonepe.png",
  BHIM: "https://devmedia.chingari.io/apipublic/upi_icons/bhim.png",
};

export const DIAMOND_IC_BLUE = "/assets/icons/diamond-blue-icon.svg",
  DIAMOND_OFFER_BG = "/assets/icons/diamond-offer-background.svg",
  HISTORY_IC = "/assets/icons/history-icon.svg",
  BANNER_BACKGROUND = "/assets/icons/banner-background.svg",
  DIAMOND_PURPLLE_IC = "/assets/icons/diamond-purplle-icon.svg";
